import { useLocationsEnabled } from "../../../../../Inventory/pages/locations/useLocationsEnabled";
import { useState, useEffect, useRef } from "react";
import { Modal, Select, notification, Spin, Checkbox } from "antd";
import { DownloadPickingList, useTaskStatus } from "../../../../../Sale/_redux/orders/ordersCrud";
import { getCeleryTask } from "../../../../../../modules/Common/constants";
import CustomButton from "../../../../../../../utility/CustomButton";
import PickingListPrintViewModal from "./print-view-modal/PickingListPrintViewModal";
import { Radio } from "antd";
const { Option } = Select;

const PickingListModal = ({ isVisible, onClose, id, publicKey, onGenerated }) => {
  const locationsEnabled = useLocationsEnabled();
  const generatedOrderIdRef = useRef(null);
  const UPC = "UPC";
  const SKU = "SKU";
  const SortOrderType = {
    A_TO_Z: 1,
    Z_TO_A: 2
  };
  const [option, setOption] = useState("withoutBarcode");
  const [imageOption, setImageOption] = useState("withoutImage");
  const [barcodeType, setBarcodeType] = useState(UPC);
  const [categorySort, setCategorySort] = useState("AZ"); // AZ | ZA
const [productSort, setProductSort] = useState("AZ");   // AZ | ZA
  const [invoicePdfLoading, setInvoicePdfLoading] = useState(false);
  const [showPinckingListPreviewModal, setShowPinckingListPreviewModal] = useState(false)
  const [taskStatus, setTaskStatus] = useState(null);
  const [checkboxState, setCheckboxState] = useState({
    isZoneChecked: false,
    isAilseChecked: false,
    isBinChecked: false,
    isUnitNoteChecked: false,
    isProductDescChecked: false,
    isSortByLocationChecked: false,
  });
  // Using the custom hook
  const { exportStatus, handleBackgroundTask, downloadUrl } = useTaskStatus(
    "pickListId", // The key to retrieve the task ID
    (statusData) => {
      setTaskStatus(statusData); // Update task status in the component
    },
    true,
    publicKey
  );

  // Check the task status periodically

  const handleGenerate = async () => {
    const params = {
      is_barcode: option === "withBarcode",
      is_image: imageOption === "withImage",
      is_zone: checkboxState.isZoneChecked,
      is_aisle: checkboxState.isAilseChecked,
      is_bin: checkboxState.isBinChecked,
      is_unit_note: checkboxState.isUnitNoteChecked,
      is_product_desc: checkboxState.isProductDescChecked,
      is_sku_barcode: barcodeType === SKU,
      sort_by_category: categorySort === "AZ" ? SortOrderType.A_TO_Z : SortOrderType.Z_TO_A,
      sort_by_product: productSort === "AZ" ? SortOrderType.A_TO_Z : SortOrderType.Z_TO_A,
      // Only sent when asked for — omitted, the list keeps its category order (#8104).
      sort_by_location: checkboxState.isSortByLocationChecked ? SortOrderType.A_TO_Z : null,
    };
    if(!params.is_barcode){
       params.is_sku_barcode=false;
    }

    try {
      setInvoicePdfLoading(true);
      const response = await DownloadPickingList(params, id, publicKey);
      generatedOrderIdRef.current = id;
      localStorage.setItem("pickListId", response.data.id);
      handleBackgroundTask();
    } catch (err) {
      err?.response?.data?.errors?.forEach((error) => notification.error({ message: error }));
    } finally {
      setInvoicePdfLoading(false);
    }
  };
  const isSpinning = invoicePdfLoading || (exportStatus && exportStatus !== 3);

  useEffect(() => {
    if (exportStatus == 'COMPLETED') {
      setShowPinckingListPreviewModal(true)
      if (downloadUrl && generatedOrderIdRef.current !== null) {
        const generatedOrderId = generatedOrderIdRef.current;
        generatedOrderIdRef.current = null;
        onGenerated?.(generatedOrderId);
      }
    }
  }, [exportStatus, downloadUrl, onGenerated]);

   const handleCheckboxChange = (checkboxName) => (e) => {
    setCheckboxState((prevState) => ({
      ...prevState,
      [checkboxName]: e.target.checked,
    }));
  };

 return (
    <>
      <Modal 
        title="How do you want to print the pick list?" 
        visible={isVisible} 
        onCancel={onClose} 
        footer={null} 
        className="picking-list-modal"
        width={550} // Adjusted for better horizontal spacing
      >
        {/* Barcode Section */}
        <div style={{ marginBottom: 20 }}>
          <div className="d-flex justify-content-between align-items-center">
            <span style={{ fontWeight: 500 }}>Barcode</span>
            {exportStatus && (
              <span style={{ fontSize: '12px' }}>
                Status: <b>{getCeleryTask(exportStatus)}</b>
              </span>
            )}
          </div>
          <Select 
            className="w-100 mt-2" 
            value={option} 
            onChange={(value) => setOption(value)}
          >
            <Option value="withBarcode">With Barcode</Option>
            <Option value="withoutBarcode">Without Barcode</Option>
          </Select>
        </div>

        {/* Image Section */}
        <div style={{ marginBottom: 20 }}>
          <div className="d-flex justify-content-between align-items-center">
            <span style={{ fontWeight: 500 }}>Image</span>
          </div>
          <Select 
            className="w-100 mt-2" 
            value={imageOption}
            onChange={(value) => setImageOption(value)}
          >
            <Option value="withoutImage">Without Image</Option>
            <Option value="withImage">With Image</Option>
          </Select>
        </div>

        {/* Barcode Type Row - Horizontal layout */}
        {option === "withBarcode" && (
          <div className="d-flex align-items-center" style={{ marginBottom: 15, gap: "10px" }}>
            <span>Barcode Type</span>
            <Select
              style={{ width: 100 }}
              value={barcodeType}
              onChange={(value) => setBarcodeType(value)}
            >
              <Option value="UPC">UPC</Option>
              <Option value="SKU">SKU</Option>
            </Select>
          </div>
        )}

        {/* Category Sorting Row */}
        <div className="d-flex align-items-center" style={{ marginBottom: 15, gap: "10px" }}>
          <span>Category Sorting</span>
          <Radio.Group
            value={categorySort}
            onChange={(e) => setCategorySort(e.target.value)}
          >
            <Radio value="AZ">A → Z</Radio>
            <Radio value="ZA">Z → A</Radio>
          </Radio.Group>
        </div>

        {/* Product Name Sorting Row */}
        <div className="d-flex align-items-center" style={{ marginBottom: 15, gap: "10px" }}>
          <span>Product Name Sorting</span>
          <Radio.Group
            value={productSort}
            onChange={(e) => setProductSort(e.target.value)}
          >
            <Radio value="AZ">A → Z</Radio>
            <Radio value="ZA">Z → A</Radio>
          </Radio.Group>
        </div>

        {/* Checkbox Row */}
        <div style={{ display: 'flex', gap: '15px', marginBottom: 20, flexWrap: 'wrap' }}>
          {/* With Stock Locations on, the three legacy toggles all produce the
              same single composed Location column, so offer one honest choice
              (#8104). Tenants without the module keep Zone / Bin / Aisle. */}
          {locationsEnabled ? (
            <Checkbox checked={checkboxState.isBinChecked} onChange={handleCheckboxChange("isBinChecked")}>
              Location
            </Checkbox>
          ) : (
            <>
              <Checkbox checked={checkboxState.isZoneChecked} onChange={handleCheckboxChange("isZoneChecked")}>
                Zone
              </Checkbox>
              <Checkbox checked={checkboxState.isBinChecked} onChange={handleCheckboxChange("isBinChecked")}>
                Bin
              </Checkbox>
              <Checkbox checked={checkboxState.isAilseChecked} onChange={handleCheckboxChange("isAilseChecked")}>
                Aisle
              </Checkbox>
            </>
          )}
          <Checkbox checked={checkboxState.isUnitNoteChecked} onChange={handleCheckboxChange("isUnitNoteChecked")}>
            Unit Note
          </Checkbox>
          <Checkbox
            checked={checkboxState.isSortByLocationChecked}
            onChange={handleCheckboxChange("isSortByLocationChecked")}
          >
            Sort by location
          </Checkbox>
          <Checkbox checked={checkboxState.isProductDescChecked} onChange={handleCheckboxChange("isProductDescChecked")}>
            Product Desc
          </Checkbox>
        </div>

        {/* Footer Buttons */}
        <div className="d-flex justify-content-end" style={{ gap: "12px", marginTop: "24px" }}>
          <CustomButton 
            label="Cancel" 
            className="picklist-modal-no-btn" 
            style={{ backgroundColor: '#f5f5f5', color: '#333', border: 'none' }}
            onClick={onClose} 
          />
          <Spin spinning={isSpinning}>
            <CustomButton 
              label="Generate" 
              className="picklist-modal-ok-btn" 
              style={{ backgroundColor: '#e91e63', color: '#fff', border: 'none' }}
              onClick={handleGenerate} 
            />
          </Spin>
        </div>
      </Modal>

      {showPinckingListPreviewModal && (
        <PickingListPrintViewModal 
          show={showPinckingListPreviewModal} 
          setShow={setShowPinckingListPreviewModal} 
          pdfLink={downloadUrl} 
          onClose={onClose} 
        />
      )}
    </>
  );
};

export default PickingListModal;
